<template>
  <div>
    <h4 class="text-secondary font-weight-bold">
      {{ this.questionario.nome }}
    </h4>
    <div v-if="!started">
      <div class="col-sm-12 col-lg-5 mx-auto my-4">
        <p class="text-justify">
          {{ this.questionario.info }} Maggiori dettagli saranno reperibili alla
          <a
            href="https://teleconsulto.online/privacy"
            class="text-secondary"
            target="_blank"
            >Privacy Policy</a
          >. Le condizioni di utilizzo sono consultabili
          <a
            href="https://teleconsulto.online/tec/"
            class="text-secondary"
            target="_blank"
            >qui</a
          >
          .
        </p>
        <!-- <p class="text-justify">
          Maggiori dettagli saranno reperibili alla
          <a href="https://teleconsulto.online/privacy" class="text-secondary"
            >Privacy Policy</a
          >. Le condizioni di utilizzo sono consultabili
          <a href="https://teleconsulto.online/tec/" class="text-secondary"
            >qui</a
          >
          .
        </p> -->
      </div>
      <b-button
        variant="primary font-weight-bold rounded-pill"
        class="col-5 mx-auto my-2"
        @click="start"
        >Conferma</b-button
      >
    </div>
    <div v-else>
      <b-tabs
        align="center"
        active-nav-item-class="font-weight-bold text-secondary border-0"
        active-tab-class="font-weight-bold text-dark"
        content-class="mt-3"
        nav-class="border-0 text-white"
        no-key-nav
        v-model="questIndex"
      >
        <b-tab
          title
          v-for="(domanda, ind) in domande"
          :key="ind"
          title-item-class="disabledTab"
        >
          <div class="col-sm-12 col-lg-7 mx-auto my-4">
            <h5 class="text-secondary">
              <span class="text-primary">{{ questionIndex(ind) }}.</span>
              {{ domanda.q }}
            </h5>
            <br />
            <div v-if="domanda.o" class="py-2">
              <div v-if="domanda.o !== 'file'">
                <b-button
                  v-for="(opzione, ind) in domanda.o"
                  :key="ind"
                  variant="outline-secondary font-weight-bold fixed__h"
                  class="col-lg-3 col-sm-4 mx-1 my-2 text__control"
                  @click="selectOption(domanda, opzione)"
                  >{{ opzione }}</b-button
                >
              </div>
              <div v-else>
                <span>Seleziona file da caricare:</span>
                <b-form-file
                  v-model="file"
                  placeholder="Scegli file o trascinalo qui..."
                  drop-placeholder="Trascina qui..."
                  browse-text="Scegli"
                  accept="image/*"
                  ref="file-input"
                  @change="onFileChange"
                ></b-form-file>
                <!-- <b-button @click="file = null">Annulla</b-button> -->
                <b-button
                  variant="primary font-weight-bold"
                  v-if="file"
                  class="col-6 mx-auto my-2"
                  @click="upload"
                >
                  <span v-if="!uploading">{{ btnText }}</span>
                  <b-spinner v-else small type="grow"></b-spinner>
                </b-button>
              </div>
              <br />
              <span v-if="domanda.o !== 'file'"
                >Se vuoi, aggiungi un commento</span
              >
            </div>
            <b-form-textarea
              v-if="domanda.o !== 'file'"
              v-model="domanda.a"
              class="my-2 py-2"
            ></b-form-textarea>
          </div>
          <b-button
            variant="secondary font-weight-bold rounded-pill"
            class="col-3 mx-auto my-2"
            @click="next"
            >Procedi</b-button
          >
          <!-- <b-button
            variant="primary"
            class="col-3 mx-auto my-2"
            @click="next"
            :disabled="domanda.a.length <1"
          >Procedi</b-button>-->
          <br />
        </b-tab>
        <b-tab title title-item-class="disabledTab">
          <div class="col-sm-12 col-lg-7 mx-auto">
            <h5 class="text-secondary">
              Grazie per aver compilato il questionario!
            </h5>
            <br />
            <p>Puoi procedere con la prenotazione.</p>
            <br />
            <b-button
              variant="primary font-weight-bold rounded-pill"
              class="col-5 mx-auto my-2"
              @click="finalizza"
              >Procedi</b-button
            >
          </div>
          <br />
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
export default {
  name: "questionario-component",
  props: ["questionario"],
  data() {
    return {
      questIndex: 0,
      started: false,
      domande: this.questionario.domande,
      file: null,
      uploading: false,
      btnText: "Salva Immagine",
    };
  },
  methods: {
    start() {
      this.started = true;
    },
    selectOption(domanda, opzione) {
      domanda.a = opzione;
    },
    next() {
      this.questIndex++;
    },
    finalizza() {
      this.$emit("end-quest", this.domande);
    },
    onFileChange(e) {
      this.file = e.target.files[0];
    },
    upload() {
      this.uploading = true;
      var url = process.env.VUE_APP_VERSION + "storage/questionario/img";
      let formData = new FormData();
      formData.append("file", this.file);
      this.$axios
        .post(url, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          // console.log(res);
          this.uploading = false;
          this.btnText = "Salvata!";
          var path = res.data.data;
          this.domande[this.questIndex].a = path;
          // this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    questionIndex(i) {
      var index = i + 1;
      return index + "/" + this.domande.length;
    },
  },
};
</script>
<style scoped>
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Scegli";
}
.custom-file-input:lang(it) ~ .custom-file-label::after {
  content: "Scegli";
}
.fixed__h {
  height: 65px;
}
</style>
